module.exports = "/_next/static/images/f0b0ad6957cd8d924152557aa48001fc-mulher-perfil-segurando-cartao-xs@3x.jpg";